import React from "react";
import styles from "./index.module.css";

const CarStats = ({ amount, imageUrl, description }) => {
  return (
    <div className={styles.mainDiv}>
      <div className={styles.statContainer}>
          <img
            src={imageUrl}
            alt="car stat"
            width={92}
            height={92}
            className={styles.statImage}
          />
        <div className={styles.textContainer}>
          <div className={styles.statAmount}>{amount}</div>
          <div className={styles.description}>{description}</div>
        </div>
      </div>
      </div>
  );
};

export default CarStats;